import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { getTagColorStyles, getTagDisplay } from 'utils/tagColor';

import { Mui } from 'components';

const useStyles = Mui.makeStyles(theme => ({
  root: {
    alignItems: 'center',
    borderRadius: 999,
    borderStyle: 'solid',
    borderWidth: 1,
    boxSizing: 'border-box',
    display: 'inline-flex',
    flexShrink: 0,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    letterSpacing: 0.2,
    lineHeight: 1,
    maxWidth: '100%',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
  sm: {
    fontSize: theme.typography.pxToRem(12),
    height: 22,
    padding: theme.spacing(0, 1.25),
  },
  md: {
    fontSize: theme.typography.pxToRem(13),
    height: 28,
    padding: theme.spacing(0, 1.5),
  },
  label: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  deleteButton: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(-0.5),
    padding: 2,
  },
  deleteIcon: {
    fontSize: 14,
  },
}));

function TagChip({ tag, name, color, size, className, onDelete, ...rest }) {
  const classes = useStyles();
  const display = getTagDisplay({ name, color, ...tag });
  const palette = getTagColorStyles(display.color);
  const label = display.name || 'Tag';

  return (
    <span
      className={clsx(classes.root, classes[size], className)}
      style={palette}
      title={label}
      {...rest}>
      <span className={classes.label}>{label}</span>
      {onDelete && (
        <Mui.IconButton
          className={classes.deleteButton}
          size="small"
          aria-label={`Remover ${label}`}
          onClick={event => {
            event.stopPropagation();
            onDelete(event);
          }}
          style={{ color: palette.color }}>
          <Mui.Icon className={classes.deleteIcon}>close</Mui.Icon>
        </Mui.IconButton>
      )}
    </span>
  );
}

TagChip.propTypes = {
  tag: PropTypes.object,
  name: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
  className: PropTypes.string,
  onDelete: PropTypes.func,
};

TagChip.defaultProps = {
  size: 'sm',
};

export default TagChip;
